import type { FormErrors } from "@repo/shared-types";

interface ErrorProps {
  errors: FormErrors;
  fieldName?: string;
}

interface ErrorMessageProps {
  message: string;
  customRender?: React.ReactNode;
}

export const ErrorMessage = ({ message, customRender }: ErrorMessageProps) => {
  return (
    <div className="flex flex-col items-start gap-1">
      <div className="first-letter:uppercase text-xs text-red">{message}</div>
      {customRender}
    </div>
  );
};

export const Error = ({ errors, fieldName }: ErrorProps) => {
  if (!errors[fieldName ?? ""]) return null;
  const error = errors[fieldName ?? ""];
  if (!error) return null;
  return <ErrorMessage message={error.message} />;
};
